<div class="modal-body">
  <div class="row">
    <h2 class="modal-title">{{ 'brapi-sync.observation-unit.heading' | translate }}</h2>
  </div>
  <div class="row">
    <div class="col">
      <app-collapsible [heading]="'brapi-sync.observation-unit.connection-info' | translate">
        <div class="card">
          <div class="card-body">
            <h5><span class="badge badge-pill text-bg-success text-white">{{context.sourceStudy.studyName}}</span></h5>
          </div>
        </div>
      </app-collapsible>
      <app-collapsible [heading]="'brapi-sync.observation-unit.observation-units-metadata' | translate">
        @if (observationUnitLoading) {
          <div class="row">
            <div class="col">
              <span class="throbber"></span>
            </div>
          </div>
        }
        @if (!observationUnitLoading) {
          <div class="row">
            <div class="col"><div class="table-responsive">
              <table class="table table-bordered table-striped table-curved">
                <caption></caption>
                <thead class="thead-light">
                  <tr>
                    <th scope="col">{{ 'brapi-sync.observation-unit.table.key' | translate }}</th>
                    <th scope="col">{{ 'brapi-sync.observation-unit.table.value' | translate }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td><span class="fw-bold">{{ 'brapi-sync.observation-unit.table.levels' | translate }}</span></td>
                    <td>
                      @if (context.sourceStudy?.observationLevels) {
                        <app-expandable-json-viewer [json]="context.sourceStudy?.observationLevels"></app-expandable-json-viewer>
                      }
                    </td>
                  </tr>
                  <tr>
                    <td><span class="fw-bold">{{ 'brapi-sync.observation-unit.table.number-of-observation-units' | translate }}</span></td>
                    <td>{{sourceObservationUnits.length}}</td>
                  </tr>
                  <tr>
                    <td><span class="fw-bold">{{ 'brapi-sync.observation-unit.table.number-of-germplasm' | translate }}</span></td>
                    <td>{{germplasmTotalCount}}</td>
                  </tr>
                </tbody>
              </table>
            </div></div>
          </div>
        }
      </app-collapsible>
      <app-collapsible [heading]="'brapi-sync.observation-unit.germplasm-mapping' | translate">
        <div class="row">
          <div class="col">
            <div class="table-responsive">
              <div class="custom-scroll-style adjustable-height">
                <table class="table table-bordered table-striped table-curved">
                  <caption></caption>
                  <thead class="sticky-header">
                    <tr>
                      <th scope="col">{{ 'brapi-sync.observation-unit.table.puid' | translate }}</th>
                      <th scope="col">{{ 'brapi-sync.observation-unit.table.source-germplasm-db-id' | translate }}</th>
                      <th scope="col">{{ 'brapi-sync.observation-unit.table.source-name' | translate }}</th>
                      <th scope="col">{{ 'brapi-sync.observation-unit.table.target-germplasm-db-id' | translate }}</th>
                      <th scope="col">{{ 'brapi-sync.observation-unit.table.target-name' | translate }}</th>
                      <th scope="col">{{ 'brapi-sync.observation-unit.table.status' | translate }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    @if (sourceGermplasm.length > 0) {
                        @for (germplasm of sourceGermplasm; track germplasm) {
                            <tr>
                                <td>{{germplasm?.germplasmPUI}}</td>
                                <td>{{germplasm?.germplasmDbId}}</td>
                                <td>{{germplasm?.germplasmName}}</td>
                                <td>{{getTargetGermplasm(germplasm)?.germplasmDbId}}</td>
                                <td>{{getTargetGermplasm(germplasm)?.germplasmName}}</td>
                                <td>
                                    @if (getTargetGermplasm(germplasm)) {
                                        <span><i class="fa fa-check text-success"></i></span>
                                    }
                                    @if (!getTargetGermplasm(germplasm)) {
                                        <span><i class="fa fa-times text-danger"></i></span>
                                    }
                                </td>
                            </tr>
                        }
                    } @else {
                        <tr><td colspan="6">{{'no.data' | translate}}</td></tr>
                    }
                  </tbody>
                </table>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div class="pagination-container">
                  <div class="pagination-box pagination-box-left">
                    <div>
                      <jhi-item-count-custom [page]="page" [total]="germplasmTotalCount" [itemsPerPage]="pageSize"></jhi-item-count-custom>
                    </div>
                  </div>
                  <div class="pagination-box" data-test="germplasmSearchResultsTablePagination">
                    <ngb-pagination [collectionSize]="germplasmTotalCount" [(page)]="page" [pageSize]="pageSize" [disabled]="germplasmLoading"
                    [maxSize]="5" [rotate]="true" (pageChange)="loadGermplasm()"></ngb-pagination>
                  </div>
                  <div class="pagination-box pagination-box-right">
                    <div class="d-flex align-items-center">
                      <label for="itemsPerPage" class="control-label control-label-left" jhiTranslate="global.items.per.page"></label>
                      <select [(ngModel)]="pageSize" class="form-select ms-2" id="itemsPerPage" [disabled]="germplasmLoading" (change)="page = 1; loadGermplasm();" style="width:95px">
                        <option value="20">20</option>
                        <option value="50">50</option>
                        <option value="75">75</option>
                        <option value="100">100</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </app-collapsible>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="cancel()">{{ 'cancel' | translate }}</button>
  <button type="button" class="btn btn-primary ms-2" (click)="post()" [disabled]="!isValid()">
    @if (isSaving) {
      <span class="throbber throbber-btn"></span>
    }
    {{ 'brapi-sync.buttons.import-observation-units' | translate }}
  </button>
  <button type="button" class="btn btn-info ms-2" (click)="next()" [disabled]="!canProceed()">
    {{ 'next' | translate }}
  </button>
</div>

<ng-template #downloadError>
    <div class="row">
        <div class="col">
            <span>{{'brapi-sync.germplasm.error.there-are-errors-during-import' | translate}} <a href="javascript:void(0)" (click)="downloadErrorsAndInfo()"> {{ 'brapi-sync.germplasm.error.download-details-here' | translate }}</a></span>
        </div>
    </div>
</ng-template>



